import { useQuery } from "@tanstack/react-query";
import api from "apis";
import { GetLatestAnalysisParams } from "apis/data-contracts";

const useLatestAnalysisQuery = () => {
  const query: GetLatestAnalysisParams = {
    page: 0,
    size: 8,
  };

  return useQuery({
    queryKey: api.dashboard.getLatestAnalysisKey(query),
    queryFn: () => api.dashboard.getLatestAnalysis(query),
    select: (res) => res.data.result,
  });
};

export default useLatestAnalysisQuery;
